import { render } from "./MenuList.vue?vue&type=template&id=ebda6b70&scoped=true&ts=true"
import script from "./MenuList.vue?vue&type=script&lang=ts"
export * from "./MenuList.vue?vue&type=script&lang=ts"

import "./MenuList.vue?vue&type=style&index=0&id=ebda6b70&scoped=true&lang=scss"

import exportComponent from "/Users/aleksandrvasilevic/Documents/Dev/WEB/Pets/phone-book/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebda6b70"]])

export default __exports__